var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolaOtros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#959595;}\n\t.st1{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bola-revision") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    className: "st0",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 10,
    cy: 17.5,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 17.5,
    cy: 17.5,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 25,
    cy: 17.5,
    r: 1.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolaOtros);
export default __webpack_public_path__ + "static/media/bola-otros.b7b37dc6ce052215c89230dac8530bc6.svg";
export { ForwardRef as ReactComponent };